module.exports = {
  GRPC_STATUS_DETAILS:'grpc-status-details'
};
